module.exports = "<div class=\"container-fluid\">\n    <!-- Content here -->\n    {{videoItem.shortDescription}}\n\n  </div>\n\n"